type FirstFactor = { strategy: string };

type EmailCodeFactor = {
  strategy: 'email_code';
  emailAddressId: string;
  safeIdentifier: string;
  primary?: boolean;
};

/**
 * Clerk returns one `email_code` factor per verified address on the login, and
 * only the typed one carries an unmasked `safeIdentifier`. Taking the first
 * factor sends the code to whichever address Clerk lists first.
 */
export function pickEmailCodeFactor(
  factors: ReadonlyArray<FirstFactor> | null | undefined,
  address: string,
): EmailCodeFactor | undefined {
  const emailCodes = (factors ?? []).filter(
    (factor): factor is EmailCodeFactor => factor.strategy === 'email_code',
  );
  const typed = address.trim().toLowerCase();
  return (
    emailCodes.find((factor) => factor.safeIdentifier.toLowerCase() === typed) ??
    emailCodes.find((factor) => factor.primary) ??
    emailCodes[0]
  );
}
